interface Term {
	id: number;
	termType: ETermType;
	nameKo: string;
	contentKo: string;
	effectiveDate: string;
	isRequired?: boolean;
}

interface ResponseGetTerms {
	terms: Term[];
}

enum ETermType {
	TERMS_OF_SERVICE = "TERMS_OF_SERVICE",
	PRIVACY_POLICY = "PRIVACY_POLICY",
	MARKETING_CONSENT = "MARKETING_CONSENT",
}

export type { Term, ResponseGetTerms };

export { ETermType };
